module.exports = (number, a, b) => {
  const [min, max] = [a, b].sort();
  return Math.min(Math.max(number, min), max);
}
